import { render, staticRenderFns } from "./PInfo.vue?vue&type=template&id=1038d9e8"
import script from "./PInfo.vue?vue&type=script&lang=js"
export * from "./PInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports